const phoneRegex =
  /^(\+?\d{1,2})?[.-\s]?\(?(\d{3})\)?[-.\s]?(\d{3})[-.\s]?(\d{4})$/;
export function isValidPhoneNumber(phone: string) {
  return phoneRegex.test(phone);
}

const emailRegex = /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i;
export function isValidEmail(email: string) {
  return emailRegex.test(email);
}

const pincodeRegex = /^\d{4}$/;
export function isValidPincode(pincode: string | undefined): boolean {
  return pincode ? pincodeRegex.test(pincode) : false;
}

const moneyRegex = /^\d+(\.\d{2})?$/;
export function isValidMoney(money: string) {
  return moneyRegex.test(money);
}
